import { Box, Icon, LinearProgress, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import CancelSubmitModal from './cancelSubmitModal'
import LinearProgressBar from './linearProgressBar'

const AltFormHeader = ({
  title,
  isPreview = true,
  isSubmit = false,
  pageCount,
  pageCurrent,
  handleExit,
}) => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const closeTab = () => {
    if (window.history.length > 1) {
      navigate(-1, {
        state: {
          ...state,
        },
      })
    } else {
      window.opener = null
      window.open('', '_self')
      window.close()
    }
  }

  const [isModalOpen, setModalOpen] = useState(false)

  const handleOpen = () => {
    setModalOpen(true)
  }

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: 75,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: 'white.main',
          borderBottom: '1px solid',
          borderBottomColor: 'gray-line.main',
          position: 'sticky',
          top: 0,
          zIndex: 999,
        }}
        px={'40px'}
      >
        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
          <Typography variant="h4">{title}</Typography>
          {isPreview ? (
            <AdxStatusBar
              status={{
                text: 'Preview',
                color: 'alternate.main',
                bgColor: 'alternate.light',
              }}
              py={1 / 3}
              sx={{ borderRadius: '4.5px' }}
            />
          ) : null}
        </Box>
        <Box display="flex" alignItems="center" gap={3}>
          <Icon
            onClick={
              isSubmit
                ? handleOpen
                : () => {
                    closeTab()
                  }
            }
            sx={{ fontSize: 25, cursor: 'pointer' }}
          >
            close
          </Icon>
        </Box>
        {isSubmit && (
          <Box
            sx={{
              width: '100%',
              position: 'absolute',
              left: 0,
              bottom: 0,
            }}
          >
            <LinearProgressBar value={((pageCurrent + 1) / pageCount) * 100} />
          </Box>
        )}
      </Box>

      {/* Close submit form modal */}
      <CancelSubmitModal isModalOpen={isModalOpen} setModalOpen={setModalOpen} />
    </>
  )
}

export default AltFormHeader
